<p class="upload-progr-bar__title bm--cut">{{ file.name }}</p>

<div
  class="upload-progr-bar__line"
  [ngClass]="{
    'upload-progr-bar__line--success': uploadImageResult.status === 'success',
    'upload-progr-bar__line--error': uploadImageResult.status === 'error'
  }"
></div>

<div class="upload-progr-bar__info">
  <p class="upload-progr-bar__size">{{ convertSize(file.size) }} MB</p>
  <p
    class="upload-progr-bar__status bm--cut"
    [ngClass]="{
      'upload-progr-bar__status--success': uploadImageResult.status === 'success',
      'upload-progr-bar__status--error': uploadImageResult.status === 'error'
    }"
  >
    {{ uploadImageResult.message }}
  </p>
</div>
